import { get } from 'utils/network';
import { ApiRoute } from '../../utils/config';
import { Menu, MenuList } from '../../models/menu.types';

// Fetch list of upcoming menus
export const fetchMenus = async (): Promise<MenuList | undefined> => {
  const {
    ok,
    parsedBody,
  } = await get<MenuList>(`${ApiRoute.MENUS}?include_cart=true`);

  if (!ok) {
    throw new Error('Network response was not ok');
  }

  return parsedBody;
};

// Fetch current menu for logged out users
export const fetchLoggedOutMenuId = async (): Promise<number | undefined> => {
  const {
    ok,
    parsedBody,
  } = await get<MenuList>(
    `${ApiRoute.MENUS}?logged_out=true`,
  );

  if (!ok) {
    throw new Error('Network response was not ok');
  }

  return parsedBody?.menus?.[0]?.id;
};

// Fetch menu & menuItem data for the given menuId
export const fetchMenuItems = async (menuId: number,
  loggedOut = false): Promise<Menu | undefined> => {
  const {
    ok,
    parsedBody,
  } = await get<Menu>(`${ApiRoute.MENUS}/${menuId}?logged_out=${loggedOut}`);

  if (!ok) {
    throw new Error('Network response was not ok');
  }
  return parsedBody;
};
